import { render, staticRenderFns } from "./TokevaDangerZone.vue?vue&type=template&id=af334d18&scoped=true"
import script from "./TokevaDangerZone.vue?vue&type=script&lang=js"
export * from "./TokevaDangerZone.vue?vue&type=script&lang=js"
import style0 from "./TokevaDangerZone.vue?vue&type=style&index=0&id=af334d18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af334d18",
  null
  
)

export default component.exports